/**
 *  登入狀態管理相關
 */

import cookies from 'js-cookie'
const authCookieKey = 'mcipToken'

/**
 * 將 token 存入 cookie
 * @param {String} token 登入後所取得的 token
 */
const setAuth = (token) => {
  cookies.set(authCookieKey, token, { expires: 1 })
}

/**
 * 取得 cookie 中所存的 token
 * @return {String} 在 cookie 中所存 token。若不存在則為 undefined (即登出狀態)
 */
const checkAuth = () => {
  return cookies.get(authCookieKey)
}

/**
 * 清除存 token 的 cookie
 */
const clearAuth = () => {
  cookies.remove(authCookieKey)
}

export default {
  setAuth,
  checkAuth,
  clearAuth,
}
